<template>
  <div class="wrapper">
    <admin-title :title="$route.meta.name" />

    <div class="header-search">
      <el-form ref="form" inline :model="searchData" label-width=" ">
        <el-form-item label="渠道名称">
          <el-input v-model="searchData.channelName" size="small" placeholder="请输入渠道名称" />
        </el-form-item>
        <el-form-item label="负责人手机号">
          <el-input v-model="searchData.companyUserMobile" size="small" placeholder="请输入负责人手机号" />
        </el-form-item>
        <el-form-item label="对接商务">
          <SelectAdmin v-model="searchData.businessUserId" />
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" icon="el-icon-search" @click="getChannelList">搜索</el-button>
          <el-button type="info" size="small" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="header-tabs">
      <el-button
        v-checkbtn="isShowBtn(AUTH_BTN.channel_list_add)"
        style="margin-left:20px"
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="$router.push({ name: 'ChannelAdd' })"
      >新增</el-button>
    </div>
    <el-divider></el-divider>

    <tp-table
        ref="channelTable"
        :tableData="list"
        :columns="columns"
        :totalNum="total"
        :current-page.sync="currentPage"
        :pageSize.sync="pageSize" />

    <div style="height:60px;"></div>
  </div>
</template>

<script>
import {
  getChannelListAPI,
  deleteChannelAPI,
  editStatusAPI,
} from './api';
import { authBtnMixin } from '@/mixins/authBtnMixin';
import SelectAdmin from '@/views/components/select-admin.vue';

const columns = [
  {
    label: 'ID',
    prop: 'id',
    minWidth: '80',
    customRender(h, row) {
      return <p>{row['id']}</p>
    }
  },
  {
    label: '渠道名称',
    prop: 'channelName',
    minWidth: '150',
    customRender(h, row) {
      return <p>{row['channelName']}</p>
    }
  },
  {
    label: '负责人',
    prop: 'companyUserName',
    minWidth: '100',
    customRender(h, row) {
      return <p>{row['companyUserName']}</p>
    }
  },
  {
    label: '负责人手机号',
    prop: 'companyUserMobile',
    minWidth: '120',
    customRender(h, row) {
      return <p>{row['companyUserMobile']}</p>
    }
  },
  {
    label: '对接商务',
    prop: 'businessUserName',
    minWidth: '100',
    customRender(h, row) {
      return <p>{row['businessUser']?.['userName']}</p>
    }
  },
  {
    label: '结算方式',
    prop: 'settleMethodDesc',
    minWidth: '100',
    customRender(h, row) {
      return <p>{row['settleMethodDesc']}</p>
    }
  },
  {
    label: '跳转方式',
    width: '100',
    customRender(h, row) {
      return (
          <div>
            <el-link
                disabled={row['status'] == 1 || !this.isShowBtn(this.AUTH_BTN.channel_list_edit)}
                style="margin-right:10px;"
                underline={false}
                type="primary"
                onClick={() => this.$router.push({ name: 'ChannelEdit', params: { id: row['id'] } })}
            >
              配置
            </el-link>
          </div>
      )
    }
  },
  {
    label: '状态',
    prop: 'status',
    minWidth: '100',
    customRender(h, row) {
      return (
          <div>
            <el-switch
                disabled={!this.isShowBtn(this.AUTH_BTN.channel_list_status)}
                class="switch"
                onChange={() => this.editStatus(row)}
                v-model={row['status']}
                active-value={true}
                inactive-value={false}
                active-text="启用"
                inactive-text="禁用"
            ></el-switch>
          </div>
      )
    }
  },
  {
    label: '创建时间',
    prop: 'createTime',
    minWidth: '180',
    customRender(h, row) {
      return <p>{row['createTime']}</p>
    }
  },
  {
    label: '操作',
    width: '180',
    fixed: 'right',
    customRender(h, row) {
      return (
        <div>
          <el-link
              disabled={row['status'] == 1 || !this.isShowBtn(this.AUTH_BTN.channel_list_edit)}
              style="margin-right:10px;"
              underline={false}
              type="primary"
              onClick={() => this.$router.push({ name: 'ChannelEdit', params: { id: row['id'] } })}
          >
            查看二维码
          </el-link>

          <el-link
              disabled={row['status'] == 1 || !this.isShowBtn(this.AUTH_BTN.channel_list_edit)}
              style="margin-right:10px;"
              underline={false}
              type="primary"
              onClick={() => this.$router.push({ name: 'ChannelEdit', params: { id: row['id'] } })}
          >
            复制链接
          </el-link>

          <el-link
              disabled={row['status'] == 1 || !this.isShowBtn(this.AUTH_BTN.channel_list_edit)}
              style="margin-right:10px;"
              underline={false}
              type="primary"
              onClick={() => this.$router.push({ name: 'ChannelEdit', params: { id: row['id'] } })}
          >
            编辑
          </el-link>

          <el-link
            disabled={row['status'] == 1 || !this.isShowBtn(this.AUTH_BTN.channel_list_del)}
            underline={false}
            type="primary"
            onClick={() => this.handleDel(row['id'])}
          >
            删除
          </el-link>
        </div>
      )
    }
  }
]

export default {
  name: 'ChannelList',
  mixins: [authBtnMixin],
  components: {SelectAdmin},
  data() {
    return {
      dialogVisible: false,
      columns,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      list: [],
      searchData: {
        channelName: '',
        companyUserMobile: '',
        businessUserId: undefined,
        status: null,
      },
      productInfo: {},
    }
  },
  provide() {
    return {
      context: this
    }
  },
  watch: {
    currentPage() {
      this.getChannelList();
    },
    pageSize() {
      this.getChannelList();
    }
  },
  mounted() {
    this.getChannelList();
  },
  methods: {
    async getChannelList() {
      const { channelName, companyUserMobile, businessUserId, status } = this.searchData;
      let params = {
        channelName,
        companyUserMobile,
        businessUserId,
        status,
        page: this.currentPage,
        pageSize: this.pageSize
      };
      const res = await getChannelListAPI(params);
      this.list = res.list || [];
      this.total = res.total;
    },
    // 状态
    editStatus(row) {
      let { id, status } = row;
      let data = { id, status };
      let statusDesc = status ? '启用' : '禁用';
      this.$confirm(`此操作将${statusDesc}该渠道, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          row.status = status;
          editStatusAPI(data).then(() => {
            this.getChannelList();
            this.$message.success('操作成功');
          })
        })
        .catch(() => {
          row.status = !status;
          this.$message({ type: 'info', message: '已取消操作' });
        })
    },
    // 删除
    handleDel(id) {
      this.$confirm('此操作将永久删除该渠道, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteChannelAPI(id).then(() => {
            this.$message({ type: 'success', message: '操作成功!' });
            this.getChannelList();
          })
        })
        .catch(() => {
          this.$message({ type: 'info', message: '已取消删除' });
        })
    },
    reset() {
      Object.assign(this._data.searchData, this.$options.data().searchData);
      this.$refs.channelTable.handleSortClear();
      this.getChannelList();
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper /deep/ {
  width: 100%;

  .header-search {
    margin-top: 20px;
  }

  .header-tabs {
    margin-bottom: 20px;
  }

  .el-divider--horizontal {
    margin: 0 0 20px;
  }
  /* switch按钮样式 */
  .switch .el-switch__label {
    position: absolute;
    display: none;
    color: #fff !important;
  }
  /*打开时文字位置设置*/
  .switch .el-switch__label--right {
    z-index: 1;
  }
  /* 调整打开时文字的显示位子 */
  .switch .el-switch__label--right span {
    margin-left: 5px;
  }
  /*关闭时文字位置设置*/
  .switch .el-switch__label--left {
    z-index: 1;
  }
  /* 调整关闭时文字的显示位子 */
  .switch .el-switch__label--left span {
    margin-left: 20px;
  }
  /*显示文字*/
  .switch .el-switch__label.is-active {
    display: block;
  }
  /* 调整按钮的宽度 */
  .switch.el-switch .el-switch__core,
  .el-switch .el-switch__label {
    width: 55px !important;
    margin: 0;
  }
}
</style>
